<template>
    <div class="wrap">
        <div class="center">
            <p class="hint">Введите идентификатор документа</p>
            <div class="search-box">
                <input type="text"
                       placeholder="0eAKVrYm"
                       maxlength="8"
                       @keyup.enter="searchDocument"
                       v-model="hash">
                <button @click="searchDocument">
                    <b-icon icon="arrow-right"></b-icon>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hash: ''
            }
        },
        methods: {
            searchDocument() {
                this.$router.push({name: 'directDocument', params:{hash: this.hash}})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrap {
        background: #f4f5fa;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    .center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .hint {
        margin-bottom: 14px;
        color: #7f8894;
        text-align: left;
    }

    .search-box {
        box-shadow: -10px 9px 21px rgba(128, 152, 213, 0.1);
        width: 272px;
        margin: 0 auto;

        input {
            height: 60px;
            line-height: 60px;
            padding: 0 0px 0 25px;
            border: 0;
            background: #fff;
            border-radius: 0;
            font-size: 22px;
            letter-spacing: 10px;
            vertical-align: top;
            width: 220px;
            font-family: 'Courier New', monospace;
            font-weight: bold;
            color: #444;

            &::placeholder {
                color: #d1d1d1;
                font-family: 'Courier New', monospace;
                font-weight: normal;
            }
        }

        button {
            height: 60px;
            line-height: 74px;
            padding-right: 22px;
            border: 0;
            background: #fff;
            color: #3498db;
            vertical-align: top;
            cursor: pointer;
            transition: none;

            &:hover {
                color: #5389ad;
            }
        }
    }
</style>